var map = {
	"./annual_meetings_en.json": 85900,
	"./en.json": 17699,
	"./en/about.json": 60445,
	"./en/ci5_2.0.json": 41588,
	"./en/combined.json": 86747,
	"./en/fellowships_prices.json": 22589,
	"./en/home.json": 36043,
	"./en/links.json": 99321,
	"./en/main.json": 309,
	"./en/meetings.json": 53086,
	"./en/standards.json": 94546,
	"./news_en.json": 96067,
	"./pages_en.json": 18006
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78026;